const _version = "2.15.7"
function version() {
    return _version
}
export default version
